import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { myLocalStorage } from "../../../StorageHelper";

const selectedSubList = myLocalStorage.getItem("latestSubList")
let subId = selectedSubList?.azureSubscriptionId || "4769af8e-ca3d-448d-bd1a-80e03ed94158";


export const getAzureAllRoles = async (latestTenant: string) => {

    let url = `${NGROK}/api/azureResources/v1/nhi-roles?tenantName=${latestTenant}&subsId=${subId}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const getAzureAllIdentity = async (latestTenant: string) => {

    let url = `${NGROK}/api/azureResources/v1/nhi?tenantName=${latestTenant}&subsId=${subId}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const getAzureAllActivity = async (latestTenant: string) => {

    let url = `${NGROK}/api/azure/analytics/get-nhi-activity?tenantName=${latestTenant}&subscriptionId=${subId}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};



export const fetchAzureK8ServiceAccounts = async (latestTenant: string) => {
    let url = `${NGROK}/api/azure/v1/kubernetes/service-accounts?tenantName=${latestTenant}&subscriptionId=${subId}&timeRangeCode=7`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const fetchAzureK8ServiceSecrets = async (latestTenant: string) => {

    let url = `${NGROK}/api/azure/v1/kubernetes/secrets?tenantName=${latestTenant}&subscriptionId=${subId}&timeRangeCode=7`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const fetchAzureK8Tokens = async (latestTenant: string) => {

    let url = `${NGROK}/api/azure/v1/kubernetes/service-accounts?tenantName=${latestTenant}&subscriptionId=${subId}&timeRangeCode=7`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};
